import React, { useEffect, useState, Fragment } from "react";
import { Button, Empty } from 'antd';
import Select from "antd/es/select/index";
import cloneDeep from 'lodash/cloneDeep';
import OptionsCard from 'ReusableComponents/OptionsCard/OptionsCard';
import unescape from "lodash/unescape";

export default function DifferentForEach(props) {
  const {
    language,
    options: defaultOptions,
    onChange,
    questions: defaultQuestions,
    currentQuestions,
  } = props;
  const [options, setOptions] = useState(defaultOptions[language])
  const [questions, setQuestions] = useState(defaultQuestions[language]);
  const dangerouslySetInnerHTML = unescape(questions)
  const [numSelects, setNumSelects] = useState(dangerouslySetInnerHTML.split("<select>").length-1)

  useEffect(() => {
    const defaultOptionsClone = cloneDeep(defaultOptions);
    defaultOptionsClone[language] = options;
    onChange(defaultOptionsClone);
  }, [options]);

  document.addEventListener('QuillUpdate', (event)=>{
    const udpatedQuestions = JSON.parse(event.detail);
    setQuestions(udpatedQuestions[language]);

    const dangerouslySetInnerHTML = unescape(udpatedQuestions[language])
    setNumSelects(dangerouslySetInnerHTML.split("<select>").length-1)
  })

  return (
    <Fragment>
      <OptionsCard options={options} setOptions={setOptions}
                   numSelects={numSelects}
                   focusAfterAdd={true}
      />
    </Fragment>
  );
};